import { Hidable, isHidden, valueOrNull } from "@/shared/value";

type LocalizedPart = { value?: string | null };

export type PersonNamePart = Hidable<LocalizedPart>;

export function namePartValue(part: PersonNamePart): string | null {
  return valueOrNull<LocalizedPart>(part)?.value ?? null;
}

/**
 * Имя целиком закрыто правами: показывать нечего, но это не пустое поле — у пользователя
 * просто нет доступа ни к одной части имени.
 */
export function isNameHidden(...parts: PersonNamePart[]): boolean {
  return parts.some(isHidden) && parts.every((part) => !namePartValue(part));
}
